import { createElementBlock as o, openBlock as n, createElementVNode as e } from "vue";
import r from "./index289.js";
const l = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function c(p, t, a, d, f, i) {
  return n(), o("svg", s, t[0] || (t[0] = [
    e("g", {
      fill: "#000",
      "fill-rule": "nonzero"
    }, [
      e("path", { d: "M23.96 13.089c9.74-3.834 20.796.835 24.82 10.546 4.068 9.82-.596 21.077-10.416 25.145-9.819 4.068-21.076-.596-25.145-10.416-4.022-9.711.495-20.829 10.094-25.007l.322-.137.324-.131Zm22.51 11.503c-3.54-8.544-13.335-12.602-21.878-9.063-8.544 3.54-12.601 13.335-9.063 21.879 3.54 8.544 13.335 12.602 21.879 9.063 8.544-3.54 12.602-13.335 9.063-21.879Z" }),
      e("path", { d: "M30.435 21.72c.647 0 1.18.492 1.244 1.123l.006.127v8.6l6.713 4.092c.55.336.749 1.028.48 1.598l-.064.12a1.25 1.25 0 0 1-1.598.481l-.12-.064-7.312-4.458a1.25 1.25 0 0 1-.59-.924l-.009-.143V22.97c0-.69.56-1.25 1.25-1.25Z" })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ r(l, [["render", c]]);
export {
  u as default
};
